import * as Sentry from '@sentry/browser';

interface SentryScopeAdditionalData {
  extra?: Parameters<Sentry.Scope['setExtras']>[0];
  fingerprint?: Parameters<Sentry.Scope['setFingerprint']>[0];
  level?: Parameters<Sentry.Scope['setLevel']>[0];
  tags?: Parameters<Sentry.Scope['setTags']>[0];
}
interface CaptureException {
  <T extends Error = Error>(error: T): string;
  <T extends Error = Error>(
    error: T,
    additional: SentryScopeAdditionalData
  ): void;
  <T extends Error = Error>(error: T, additional?: SentryScopeAdditionalData):
    | undefined
    | string;
}
/**
 * Send an error to sentry.
 */
export const captureException = ((error, additional) => {
  if (additional) {
    Sentry.withScope(scope => {
      if (additional.extra) {
        scope.setExtras(additional.extra);
      }
      if (additional.fingerprint) {
        scope.setFingerprint(additional.fingerprint);
      }
      if (additional.level) {
        scope.setLevel(additional.level);
      }
      if (additional.tags) {
        scope.setTags(additional.tags);
      }
      Sentry.captureException(error, scope);
    });
  } else {
    return Sentry.captureException(error);
  }
}) as CaptureException;

export const Severity = {
  Fatal: 'fatal',
  Error: 'error',
  Warning: 'warning',
  Log: 'log',
  Info: 'info',
  Debug: 'debug',
} as const satisfies Record<
  'Fatal' | 'Error' | 'Warning' | 'Log' | 'Info' | 'Debug',
  Sentry.SeverityLevel
>;
